// extracted by mini-css-extract-plugin
export default {"output":"ama_output__yYE0R","input":"ama_input__lXsuP","box":"ama_box__NY1zI","text":"ama_text__2x5th"};